var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnounceBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.093 17.4808V10.6434C25.093 4.74913 20.3439 0 14.4495 0C8.55523 0 3.83979 4.74913 3.83979 10.6434V17.4808L1.07788 22.9373H27.9223L25.093 17.4808Z",
    fill: "#5A6BEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96997 24.5195C9.96997 26.9783 11.9909 28.9992 14.4496 28.9992C16.9084 28.9992 18.9293 26.9783 18.9293 24.5195H9.96997Z",
    fill: "#5A6BEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounceBell);
export default __webpack_public_path__ + "static/media/announce-bell.937117d90946251caa2a66a5c62f241c.svg";
export { ForwardRef as ReactComponent };